import React, { useEffect, useState, useRef } from "react";
import "./_account.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { ProfileIcon } from "./assets/ProfileIcon";
import { MailIcon } from "./assets/MailIcon";
import { RadSoftwareBackground } from "../_assets/radsoftware-bg";
import { SignOutIcon } from "./assets/sign-out-icon";
import { AccountTile } from "./components/AccountTile";
import { moneyFormatter } from "../../utils/moneyFormatter";
import RadSoftLogo from "../_assets/RadSoftLogo.png";
import {
  useSignOut,
  useIsAuthenticated,
  useAuthHeader,
  useAuthUser,
} from "react-auth-kit";
import DepositModalHelpers from "../_assets/helpers";
import { phoneFormatter } from "../../utils/phoneFormatter";
import { isValidEmail } from "../../utils/isValidEmail";
import { BarDiceNav } from "../../games/BarDice100/controller/components/BarDiceNav";
import { TextFieldGroup } from "./components/TextFieldGroup"
import { isProfane } from "../../utils/profanityChecker";
import { i18nEn, i18nPt } from "./assets/i18n";

import { Modal } from "../../utils/modal"
import { fetcher } from "../../utils/fetcher";
import { loadToaster } from "../../utils/toast";

const Style = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "90%",
    maxWidth: "450px",
    maxHeight: "1000px",
    margin: "0 auto",
    // flexGrow: "1",
    // marginTop: "1rem",
    // marginLeft: "1rem",
    // marginRight: "1rem",
    // marginBottom: "1rem",
  },
  navbar: {
    marginTop: "1rem",
    marginBottom: "1rem"
    // display: "flex",
    // flexDirection: "row",
  },
  page: {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    justifyContent: "space-between",
    // border: "white solid 3px"
  },
  topGroup: {
    display: "flex",
    flexDirection: "column",
    flexGrow: "0",
    alignItems: "stretch",
    // border: "white solid 3px"
  },
  bottomGroup: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem",
    // border: "white solid 3px"
  },
  topGroupBtnsRow: {
    display: "flex",
    flexGrow: "1",
    justifyContent: "space-between",
    // border: "white solid 3px"
  },
  welcome: {
    fontFamily: "Days One",
  },
  updateYourInfo: {
    fontFamily: "Days One",
    fontSize: "14px",
    color: "grey",
    paddingBottom: "0.5em",
  },
  modal: {
    display: " flex",
    flexDirection: " column",
    // height: " 20vh",
    justifyContent: "space-between",
    background: " #181C27",
    border: " 2px solid #686868",
    borderRadius: " 12px",
    marginLeft: "1.2rem",
    marginRight: "1.2rem",
    
  },
  modalText: {
    paddingTop: "3vh",
    paddingLeft: " 4vw",
    paddingRight: " 4vw",
    fontFamily: "Open Sans",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: " center",
    marginBottom: "0.6rem",
    color: "lightgrey",
  },
  modalButtonsRow: {
    display: " flex",
    justifyContent: "space-around",
    borderTop: "solid 1px #686868",
  },
  modalButtonLeft: {
    height: "38px",
    flexBasis: "50%",
    flexGrow: "1",
    background: "#181C27",
    borderBottomLeftRadius: "12px",
    // borderBottomRightRadius: "12px",
    // // border: " 2px solid #686868",
    borderTop: "none",
    borderLeft: "none",
    borderBottom: "none",
    borderRight: "solid 0.5px #686868",
    color: "#767F86",
    fontWeight: "bold",
  },
  modalButtonRight: {
    height: "38px",
    flexBasis: "50%",
    flexGrow: "1",
    background: "#181C27",
    // borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    borderTop: "none",
    borderRight: "none",
    borderBottom: "none",
    borderLeft: "solid 0.5px #686868",
    color: "#298DE6",
    fontWeight: "bold",
  },
};

export const Account = (props) => {
  const location = useLocation();
  const signOut = useSignOut();
  const navigate = useNavigate();
  const authenticated = useIsAuthenticated();
  const authHeader = useAuthHeader();
  const auth = useAuthUser();
  const inputRefUsername = useRef(null);
  const inputRefFirstName = useRef(null);
  const inputRefLastName = useRef(null);
  const inputRefEmail = useRef(null);
  const user = props.user;
  const [edit, setEdit] = useState(false);
  const [displayedUsername, setDisplayedUsername] = useState("");
  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState(<></>)

  useEffect(() => {
    if (!authenticated()) {
      navigate("/login");
    }
    setDisplayedUsername(username)
  }, []);

  const [errors, setErrors] = useState({});
  const defaultUsername = localStorage.getItem("username") ?? auth()?.username ?? "";
  const defaultFirstName = auth()?.firstName || "";
  const defaultLastName = auth()?.lastName || "";
  const defaultEmail = auth()?.email || "";

  // Initialize state with default values
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [firstName, setFirstName] = useState(defaultFirstName);
  const [lastName, setLastName] = useState(defaultLastName);
  const [email, setEmail] = useState(defaultEmail);

  // Translations config
  const i18n = props.jogo ? i18nPt : i18nEn;
  // const i18n = props.jogo ? i18nEn: i18nPt;

  // Track whether the inputs have changed
  const inputsChanged =
    username !== defaultUsername ||
    firstName !== defaultFirstName ||
    lastName !== defaultLastName ||
    email !== defaultEmail;

  const handleFocus = (event) => {
    const input = event.target;

    input.setSelectionRange(input.value.length, input.value.length);
  };

  const handleSave = async (e) => {
    // console.log("handleSave triggered");
    // console.log("what is email?", (email));
    // console.log("is email valid?", isValidEmail(email));
    // console.log("what is username?", (username));
    // console.log("is username profane?", isProfane(username));
    // console.log("is username empty?", username.trim() == "");
    e.preventDefault();

    if (isProfane(username)) {
      setUsername("");
      setErrors({username:i18n.usernameProfanityWarning});
    }

    if (username.trim() == "") {
      setUsername("");
      setErrors({username:i18n.required});
    }

    // if (email.trim() == "") {
    //   setEmail("");
    //   setErrors({email:i18n.required});
    // }

    // if (email.trim() == "" && username.trim() == "") {
    //   setEmail("");
    //   setErrors({email:i18n.required});
    //   setUsername("");
    //   setErrors({username:i18n.required, email:i18n.required});
    // }

    if (
      // isValidEmail(email) && 
      !isProfane(username) && 
        username.trim() !== "") {
      await fetcher(
        "PUT", 
        authHeader(), 
        props.backend.current+`/users/${auth().id}/`,
        {username, firstName, lastName, email}
      ).then(data => {
        // setEdit(false)
        localStorage.setItem("username", username)
        props.setUser({
          ...props.user, 
          username, 
          // firstName, 
          // lastName, 
          // email
        })
        loadToaster(
          (<div>{i18n.saveSuccessful}</div>), 
          props.toasts, 
          props.setToasts,
          2500
        )
      })
    }
  };

  const handleModal = () => {
    if (!modalOpen) {
      setModalOpen(true)
      setModalData(
        <div style={Style.modal}>
          <div style={Style.modalText}>{i18n.emailDisabledMessage}</div>
          <div style={Style.modalButtonsRow}>
            <button style={Style.modalButtonLeft} onClick={() => { navigate("/account/support"); }}>
              {i18n.getInTouch.toUpperCase()}
            </button>
            <button style={Style.modalButtonRight} onClick={(e)=>{setModalOpen(false)}}>
              {i18n.ok.toUpperCase()}
            </button>
          </div>
        </div>
      )
    }
  }
  
  return (
    <div style={Style.container}>
      <section style={Style.navbar}>
        <BarDiceNav
          balance={props.balance}
          user={props.user}
          selectedLocation={props.selectedLocation}
          bet={0}
          demo={props.demo}
          jogo={props.jogo}
          jackpot={props.jackpotValue}
          modalOpen={props.modalOpen}
          modalData={props.modalData}
          setModalOpen={props.setModalOpen}
          setModalData={props.setModalData}
        />
      </section>
      <section style={Style.page}>
        <section style={Style.topGroup}>
          {
            edit ? (<>
              <h2 style={Style.welcome}>
                {i18n.welcome}{props.user?.username 
                  ? `, ${props.user.username}!` 
                  : "!"
                }
              </h2>
              <h3 style={Style.updateYourInfo}>{i18n.updateYourInfo}</h3>
              <TextFieldGroup
                disabled={false}
                reference={inputRefUsername}
                id="username"
                name="username"
                placeholder={i18n.username}
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setErrors({username:""});
                }}
                icon={"profile"}
                iconSize={19}
                className={!!errors?.username ? "error" : ""}
                requiredText={errors?.username}></TextFieldGroup>
                <div onClick={handleModal}>
              <TextFieldGroup
                disabled={true}
                reference={inputRefEmail}
                id="email"
                name="email"
                placeholder={i18n.email}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={handleFocus}
                icon="email"
                iconSize={19}
                className={!!errors?.email ? "error" : ""}
                requiredText={errors?.email}></TextFieldGroup>
                </div>
              
              <div style={Style.topGroupBtnsRow}>
                {/* Save button */}
                <button
                  className={ `update-save ${inputsChanged ? "active" : ""}`}
                  onClick={handleSave}
                  // disabled={!inputsChanged}
                >
                  {i18n.save}
                </button>
                {/* Cancel button */}
                <button
                  onClick={() => { setEdit(false) }}
                  className="update-cancel">
                  {i18n.cancel}
                </button>
              </div>
              <Modal modalOpen={modalOpen} setModalOpen={setModalOpen} element={modalData} />

            </>) : (<>
              <AccountTile
                label={i18n.editProfile}
                icon={"edit"}
                iconSize={20}
                onClick={() => {setEdit(!edit)}}
              />
              <AccountTile
                label={i18n.support}
                icon={"support"}
                iconSize={20}
                onClick={() => {navigate("/account/support")}}
              />
              <AccountTile
                label={i18n.signout}
                icon={"signout"}
                iconSize={20}
                onClick={() => {
                  signOut();
                  navigate("/login", {replace: true, state: {}});
                }}
              />
            </>)}
        </section>
        <section style={Style.bottomGroup}>
          <div className="bottom-button" onClick={() => navigate("/")}>
            {i18n.returnHome}
          </div>
        </section>
      </section>
    </div>
  );
};










export const RadSoftwareIcon = (props) => {
  return (
    <svg
      style={{ zIndex: "-1000" }}
      width="112"
      height="37"
      viewBox="0 0 112 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9511 17.0252C16.9511 18.0953 16.6893 18.9149 16.1656 19.4841C15.6534 20.0419 14.9362 20.4004 14.0141 20.5598V20.594C14.2532 20.6964 14.4809 20.8956 14.6972 21.1916C14.9134 21.4762 15.1354 21.7779 15.3631 22.0966C15.6022 22.404 15.8583 22.6772 16.1315 22.9162C16.4047 23.1553 16.7121 23.2748 17.0536 23.2748C17.1219 23.2748 17.1845 23.2748 17.2414 23.2748C17.2983 23.2748 17.3495 23.2691 17.3951 23.2577C17.4406 23.2463 17.4861 23.235 17.5317 23.2236V24.897C17.452 24.9197 17.3609 24.9368 17.2585 24.9482C17.0877 24.9823 16.8259 24.9994 16.473 24.9994C16.0404 24.9994 15.6477 24.9026 15.2948 24.7091C14.9533 24.5042 14.6346 24.2595 14.3386 23.9749C14.054 23.6789 13.7865 23.3602 13.536 23.0187C13.2856 22.6658 13.0465 22.347 12.8189 22.0624C12.5912 21.7665 12.3635 21.5217 12.1359 21.3282C11.9196 21.1233 11.6919 21.0209 11.4528 21.0209H10.5478V23.104L12.2383 23.2748V24.8799H6.89372V23.2748L8.32805 23.104V14.9249L6.89372 14.7371V13.132H12.9213C13.5019 13.132 14.0369 13.2174 14.5264 13.3882C15.0273 13.5589 15.4542 13.8094 15.8071 14.1395C16.1713 14.4696 16.4502 14.8794 16.6438 15.3689C16.8487 15.847 16.9511 16.3991 16.9511 17.0252ZM12.4774 19.245C13.1945 19.245 13.7409 19.0856 14.1166 18.7669C14.4923 18.4368 14.6801 17.8961 14.6801 17.1447C14.6801 16.4048 14.4638 15.8584 14.0312 15.5055C13.5986 15.1526 13.0522 14.9762 12.392 14.9762H10.5478V19.245H12.4774ZM22.1526 16.7862C22.5851 16.7862 22.9551 16.8488 23.2625 16.974C23.5698 17.0878 23.8202 17.2187 24.0138 17.3667C24.2301 17.5375 24.4122 17.7253 24.5602 17.9302H24.6114L24.9017 16.9057H26.4897V22.7113C26.4897 22.9162 26.5409 23.0642 26.6434 23.1553C26.7458 23.2463 26.8654 23.2919 27.002 23.2919C27.1499 23.2919 27.2467 23.2862 27.2922 23.2748C27.3378 23.2634 27.3719 23.252 27.3947 23.2406V24.7945C27.3378 24.8287 27.2524 24.8628 27.1386 24.897C27.0475 24.9197 26.9223 24.9425 26.7629 24.9653C26.6035 24.988 26.4043 24.9994 26.1653 24.9994C25.8921 24.9994 25.6587 24.9596 25.4652 24.8799C25.2717 24.8002 25.1123 24.7034 24.9871 24.5896C24.8618 24.4644 24.7708 24.3278 24.7139 24.1798C24.6569 24.0204 24.6285 23.8611 24.6285 23.7017V23.6334H24.5773C24.5659 23.6448 24.5203 23.7245 24.4407 23.8724C24.361 24.009 24.2244 24.1627 24.0308 24.3335C23.8487 24.5042 23.5926 24.6579 23.2625 24.7945C22.9323 24.9311 22.5168 24.9994 22.016 24.9994C21.5151 24.9994 21.0483 24.914 20.6158 24.7433C20.1832 24.5725 19.8018 24.3164 19.4717 23.9749C19.153 23.6334 18.9025 23.2065 18.7204 22.6942C18.5383 22.1706 18.4472 21.5673 18.4472 20.8842C18.4472 20.224 18.544 19.6377 18.7375 19.1255C18.9424 18.6132 19.2099 18.1863 19.54 17.8448C19.8815 17.4919 20.2743 17.2301 20.7182 17.0594C21.1736 16.8772 21.6517 16.7862 22.1526 16.7862ZM22.6648 23.2406C23.1202 23.2406 23.4787 23.1667 23.7406 23.0187C24.0024 22.8707 24.1959 22.7284 24.3211 22.5918V19.3645C24.1959 19.1596 23.9853 18.9718 23.6893 18.8011C23.4047 18.6303 23.0746 18.5449 22.699 18.5449C22.0501 18.5449 21.5378 18.7441 21.1622 19.1426C20.7865 19.541 20.5987 20.1272 20.5987 20.9013C20.5987 21.6868 20.7979 22.273 21.1963 22.6601C21.5948 23.0471 22.0843 23.2406 22.6648 23.2406ZM32.0715 16.7862C32.5154 16.7862 32.8854 16.8374 33.1814 16.9398C33.4773 17.0309 33.7164 17.1391 33.8985 17.2643C34.0807 17.3781 34.2116 17.4863 34.2913 17.5887C34.371 17.6912 34.4108 17.7481 34.4108 17.7595H34.4791C34.4563 17.6342 34.4393 17.5147 34.4279 17.4009C34.4051 17.3098 34.388 17.2244 34.3766 17.1447C34.3766 17.0651 34.3766 17.0195 34.3766 17.0081V13.9175L33.1814 13.7467V12.1417H36.5452V23.104L37.621 23.2748V24.8799H34.9401L34.6669 23.6334H34.5986C34.4506 23.8838 34.2571 24.1115 34.0181 24.3164C33.8132 24.4871 33.5456 24.6465 33.2155 24.7945C32.8968 24.9311 32.4984 24.9994 32.0202 24.9994C31.5194 24.9994 31.0526 24.9197 30.6201 24.7604C30.1989 24.601 29.8289 24.3562 29.5102 24.0261C29.1914 23.696 28.941 23.2748 28.7588 22.7625C28.5881 22.2389 28.5027 21.6185 28.5027 20.9013C28.5027 20.2183 28.5938 19.6207 28.7759 19.1084C28.9581 18.5848 29.2085 18.1522 29.5272 17.8107C29.8574 17.4692 30.2387 17.213 30.6713 17.0423C31.1039 16.8715 31.5706 16.7862 32.0715 16.7862ZM32.7545 23.2406C33.1301 23.2406 33.4603 23.1553 33.7449 22.9845C34.0408 22.8138 34.2457 22.6259 34.3596 22.421V19.2109C34.2343 19.0629 34.0465 18.9149 33.7961 18.7669C33.5456 18.6189 33.1871 18.5449 32.7203 18.5449C32.1398 18.5449 31.6446 18.7384 31.2348 19.1255C30.8364 19.5125 30.6371 20.0988 30.6371 20.8842C30.6371 21.6583 30.825 22.2446 31.2006 22.643C31.5877 23.0414 32.1056 23.2406 32.7545 23.2406ZM38.8124 21.96C38.8124 21.8462 38.8181 21.7437 38.8294 21.6526C38.8408 21.5616 38.8579 21.4819 38.8807 21.4136C38.9034 21.3339 38.9319 21.2656 38.966 21.2087L41.1688 21.0379C41.146 21.0835 41.1289 21.129 41.1175 21.1745C41.0948 21.2884 41.0834 21.3908 41.0834 21.4819C41.0834 21.9828 41.2598 22.3812 41.6127 22.6772C41.977 22.9618 42.4836 23.104 43.1324 23.104C43.9407 23.104 44.4985 22.9845 44.8058 22.7455C45.1246 22.495 45.2839 22.1877 45.2839 21.8234C45.2839 21.4136 45.1189 21.1005 44.7887 20.8842C44.47 20.6566 44.0659 20.4687 43.5764 20.3208C43.0983 20.1614 42.5746 20.0077 42.0055 19.8597C41.4363 19.7004 40.9069 19.4898 40.4175 19.2279C39.9393 18.9547 39.5352 18.5962 39.2051 18.1522C38.8864 17.7082 38.727 17.1163 38.727 16.3764C38.727 15.9665 38.8067 15.5624 38.966 15.164C39.1368 14.7542 39.3929 14.3956 39.7344 14.0883C40.0873 13.7695 40.5313 13.5134 41.0663 13.3199C41.6127 13.115 42.2616 13.0125 43.0129 13.0125C43.7642 13.0125 44.4074 13.0979 44.9424 13.2686C45.4774 13.428 45.91 13.65 46.2401 13.9346C46.5817 14.2192 46.8321 14.5493 46.9915 14.9249C47.1508 15.2892 47.2305 15.682 47.2305 16.1031C47.2305 16.2284 47.2191 16.3365 47.1964 16.4276C47.185 16.5186 47.1679 16.5983 47.1451 16.6666C47.111 16.7463 47.0825 16.8146 47.0598 16.8715L44.9766 17.0594C44.988 17.0138 44.9993 16.9683 45.0107 16.9228C45.0221 16.8772 45.0335 16.826 45.0449 16.7691C45.0563 16.7122 45.0619 16.6496 45.0619 16.5813C45.0619 16.1031 44.9026 15.7104 44.5838 15.4031C44.2651 15.0843 43.7471 14.9249 43.03 14.9249C42.4039 14.9249 41.9087 15.0502 41.5444 15.3006C41.1801 15.551 40.998 15.8926 40.998 16.3251C40.998 16.7463 41.1574 17.0708 41.4761 17.2984C41.8062 17.5261 42.2104 17.7139 42.6885 17.8619C43.178 18.0099 43.7016 18.1579 44.2594 18.3059C44.8286 18.4425 45.3522 18.6417 45.8303 18.9035C46.3198 19.1539 46.7239 19.4955 47.0427 19.928C47.3728 20.3492 47.5379 20.9241 47.5379 21.6526C47.5379 22.108 47.4525 22.5406 47.2817 22.9504C47.1224 23.3488 46.8662 23.7017 46.5134 24.009C46.1605 24.3164 45.7108 24.5611 45.1644 24.7433C44.618 24.914 43.9634 24.9994 43.2007 24.9994C42.3925 24.9994 41.7095 24.914 41.1517 24.7433C40.5939 24.5725 40.1386 24.3449 39.7857 24.0603C39.4442 23.7757 39.1937 23.4512 39.0343 23.087C38.8864 22.7227 38.8124 22.347 38.8124 21.96ZM56.9775 20.8842C56.9775 22.2617 56.6018 23.2919 55.8505 23.9749C55.1106 24.6579 54.1031 24.9994 52.8282 24.9994C51.5646 24.9994 50.5571 24.6579 49.8058 23.9749C49.0545 23.2919 48.6789 22.2617 48.6789 20.8842C48.6789 20.2012 48.7756 19.6036 48.9691 19.0913C49.174 18.5791 49.4586 18.1522 49.8229 17.8107C50.1872 17.4692 50.6254 17.213 51.1377 17.0423C51.65 16.8715 52.2135 16.7862 52.8282 16.7862C53.4543 16.7862 54.0178 16.8715 54.5186 17.0423C55.0309 17.213 55.4692 17.4692 55.8334 17.8107C56.1977 18.1522 56.4766 18.5791 56.6701 19.0913C56.875 19.6036 56.9775 20.2012 56.9775 20.8842ZM52.8282 23.2406C53.4087 23.2406 53.8868 23.0471 54.2625 22.6601C54.6495 22.2617 54.8431 21.6697 54.8431 20.8842C54.8431 20.0988 54.6438 19.5125 54.2454 19.1255C53.847 18.7384 53.3746 18.5449 52.8282 18.5449C52.2818 18.5449 51.8093 18.7384 51.4109 19.1255C51.0239 19.5125 50.8304 20.0988 50.8304 20.8842C50.8304 21.6697 51.0182 22.2617 51.3938 22.6601C51.7695 23.0471 52.2476 23.2406 52.8282 23.2406ZM58.1523 24.8799V23.2748L59.2281 23.104V18.5791H58.1353V16.9057H59.2281V15.3348C59.2281 13.1036 60.2981 11.988 62.4383 11.988C62.6887 11.988 62.9164 12.0051 63.1213 12.0392C63.3262 12.0734 63.5026 12.1132 63.6506 12.1587C63.8214 12.2043 63.975 12.2555 64.1116 12.3124V14.1224C64.032 14.0883 63.9295 14.0484 63.8043 14.0029C63.7018 13.9801 63.5709 13.9573 63.4116 13.9346C63.2636 13.9004 63.0814 13.8834 62.8651 13.8834C62.3529 13.8834 61.9772 14.0086 61.7382 14.259C61.5105 14.5094 61.3967 14.8737 61.3967 15.3518V16.9057H63.9921V18.5791H61.3967V23.1894L63.1554 23.2748V24.8799H58.1523ZM67.7582 14.6517V16.9057H70.3365V18.5791H67.7582V21.6868C67.7582 22.1308 67.8549 22.4779 68.0484 22.7284C68.2534 22.9788 68.5721 23.104 69.0047 23.104C69.2551 23.104 69.4714 23.0927 69.6535 23.0699C69.8357 23.0471 69.9893 23.0187 70.1146 22.9845C70.2512 22.9504 70.365 22.9105 70.4561 22.865V24.675C70.3081 24.7433 70.1316 24.8002 69.9267 24.8457C69.756 24.8913 69.5511 24.9254 69.312 24.9482C69.0844 24.9823 68.8282 24.9994 68.5436 24.9994C66.5743 24.9994 65.5896 23.9407 65.5896 21.8234V18.5791H64.4797V16.9057H65.5896L65.914 14.6517H67.7582ZM73.9692 24.8799L72.0909 18.6815L70.9469 18.5108V16.9057H75.1303V18.5108L74.3278 18.6815L75.3865 22.9333H75.5572L77.0769 16.9057H79.0747L80.6115 22.9333H80.7652L81.8239 18.6815L80.9701 18.5108V16.9057H85.1365V18.5108L83.9924 18.6815L82.1141 24.8799H79.3479L78.1014 19.8768H77.9819L76.7354 24.8799H73.9692ZM89.3701 16.7862C89.8027 16.7862 90.1726 16.8488 90.48 16.974C90.7874 17.0878 91.0378 17.2187 91.2313 17.3667C91.4476 17.5375 91.6297 17.7253 91.7777 17.9302H91.8289L92.1192 16.9057H93.7072V22.7113C93.7072 22.9162 93.7585 23.0642 93.8609 23.1553C93.9634 23.2463 94.0829 23.2919 94.2195 23.2919C94.3675 23.2919 94.4642 23.2862 94.5098 23.2748C94.5553 23.2634 94.5895 23.252 94.6122 23.2406V24.7945C94.5553 24.8287 94.4699 24.8628 94.3561 24.897C94.265 24.9197 94.1398 24.9425 93.9804 24.9653C93.8211 24.988 93.6219 24.9994 93.3828 24.9994C93.1096 24.9994 92.8762 24.9596 92.6827 24.8799C92.4892 24.8002 92.3298 24.7034 92.2046 24.5896C92.0794 24.4644 91.9883 24.3278 91.9314 24.1798C91.8745 24.0204 91.846 23.8611 91.846 23.7017V23.6334H91.7948C91.7834 23.6448 91.7379 23.7245 91.6582 23.8724C91.5785 24.009 91.4419 24.1627 91.2484 24.3335C91.0662 24.5042 90.8101 24.6579 90.48 24.7945C90.1499 24.9311 89.7344 24.9994 89.2335 24.9994C88.7326 24.9994 88.2659 24.914 87.8333 24.7433C87.4007 24.5725 87.0194 24.3164 86.6893 23.9749C86.3705 23.6334 86.1201 23.2065 85.9379 22.6942C85.7558 22.1706 85.6647 21.5673 85.6647 20.8842C85.6647 20.224 85.7615 19.6377 85.955 19.1255C86.1599 18.6132 86.4274 18.1863 86.7576 17.8448C87.0991 17.4919 87.4918 17.2301 87.9358 17.0594C88.3911 16.8772 88.8692 16.7862 89.3701 16.7862ZM89.8824 23.2406C90.3377 23.2406 90.6963 23.1667 90.9581 23.0187C91.2199 22.8707 91.4134 22.7284 91.5387 22.5918V19.3645C91.4134 19.1596 91.2029 18.9718 90.9069 18.8011C90.6223 18.6303 90.2922 18.5449 89.9165 18.5449C89.2676 18.5449 88.7554 18.7441 88.3797 19.1426C88.0041 19.541 87.8162 20.1272 87.8162 20.9013C87.8162 21.6868 88.0155 22.273 88.4139 22.6601C88.8123 23.0471 89.3018 23.2406 89.8824 23.2406ZM102.311 18.9035C102.266 18.8807 102.163 18.8523 102.004 18.8181C101.856 18.784 101.651 18.7669 101.389 18.7669C100.957 18.7669 100.592 18.8409 100.296 18.9889C100.012 19.1369 99.7728 19.3076 99.5793 19.5011C99.3972 19.6947 99.2606 19.8825 99.1695 20.0646C99.0898 20.2468 99.0386 20.372 99.0158 20.4403V23.0699L100.399 23.1553V24.8799H95.7544V23.2748L96.8472 23.104V18.6815L95.7544 18.5108V16.9057H98.4523L98.6914 18.9035H98.7597C98.8735 18.5051 99.0443 18.1522 99.2719 17.8448C99.4655 17.583 99.733 17.344 100.074 17.1277C100.427 16.9 100.888 16.7862 101.458 16.7862C101.662 16.7862 101.845 16.7975 102.004 16.8203C102.163 16.8431 102.266 16.8545 102.311 16.8545V18.9035ZM105.108 21.3624C105.199 22.0112 105.45 22.4893 105.86 22.7967C106.281 23.0927 106.81 23.2406 107.448 23.2406C107.858 23.2406 108.21 23.2008 108.506 23.1211C108.802 23.0301 109.047 22.9333 109.241 22.8308C109.457 22.7056 109.639 22.5633 109.787 22.404L110.555 24.009C110.339 24.2026 110.066 24.3676 109.736 24.5042C109.451 24.6294 109.093 24.7433 108.66 24.8457C108.227 24.9482 107.71 24.9994 107.106 24.9994C106.491 24.9994 105.928 24.914 105.416 24.7433C104.903 24.5725 104.465 24.3164 104.101 23.9749C103.737 23.6334 103.452 23.2065 103.247 22.6942C103.042 22.1706 102.94 21.5673 102.94 20.8842C102.94 20.2012 103.037 19.6036 103.23 19.0913C103.435 18.5791 103.72 18.1522 104.084 17.8107C104.448 17.4692 104.881 17.213 105.382 17.0423C105.894 16.8715 106.452 16.7862 107.055 16.7862C107.681 16.7862 108.216 16.9 108.66 17.1277C109.115 17.344 109.491 17.6229 109.787 17.9644C110.083 18.3059 110.299 18.6872 110.436 19.1084C110.584 19.5296 110.658 19.9394 110.658 20.3378C110.658 20.5086 110.652 20.6566 110.641 20.7818C110.629 20.907 110.612 21.0152 110.59 21.1062C110.567 21.2087 110.544 21.2941 110.521 21.3624H105.108ZM107.072 18.4083C106.514 18.4083 106.065 18.562 105.723 18.8694C105.382 19.1767 105.177 19.5865 105.108 20.0988H108.677C108.654 19.5182 108.484 19.0913 108.165 18.8181C107.846 18.5449 107.482 18.4083 107.072 18.4083Z"
        fill="#D0D0D0"
      />
      <path
        d="M1 36.2V1L59.5945 5.73V10.9H58.2876V6.94L2.52476 2.65V34.77L58.2876 30.04V26.3H59.5945V31.47L1 36.2Z"
        fill="#D0D0D0"
        stroke="#D0D0D0"
        strokeWidth="0.218915"
      />
    </svg>
  );
};
